import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=403142a6&scoped=true&"
import script from "./PageResult.vue?vue&type=script&lang=js&"
export * from "./PageResult.vue?vue&type=script&lang=js&"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=403142a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403142a6",
  null
  
)

export default component.exports